export const CHANGE_COURSE_DATA = 'course/CHANGE_COURSE_DATA';
export const CHANGE_COURSE_PROJECT_DATA = 'course/CHANGE_COURSE_PROJECT_DATA';
export const CHANGE_COURSE_LIVE_DATA = 'course/CHANGE_COURSE_LIVE_DATA';
export const CHANGE_COURSE_EXPERIMENT_DATA = 'course/CHANGE_COURSE_EXPERIMENT_DATA';
export const CHANGE_NEW_LISTS = 'course/CHANGE_NEW_LISTS';
export const CLEAR_NEW_LISTS = 'course/CLEAR_NEW_LISTS';
export const CLEAR_NEW_PROJECT_LISTS = 'course/CLEAR_NEW_PROJECT_LISTS';
export const CHANGE_NEW_LIVE_LISTS = 'course/CHANGE_NEW_LIVE_LISTS';
export const CHANGE_NEW_EXPER_LISTS = 'course/CHANGE_NEW_EXPER_LISTS';
export const CHANGE_CATEGORY_LIST = 'course/CHANGE_CATEGORY_LIST';
export const CHANGE_CATEGORY = 'course/CHANGE_CATEGORY';
export const CHANGE_PAGE_SIZE ='course/CHANGE_PAGE_SIZE';
export const CHANGE_NEW_PROJECT_LISTS = 'course/CHANGE_NEW_PROJECT_LISTS';
export const CHANGE_SEARCH_TITLE = 'course/CHANGE_SEARCH_TITLE';
export const CHANGE_SEARCH_CATE = 'course/CHANGE_SEARCH_CATE';
export const CHANGE_CATEGORY_ID = 'course/CHANGE_CATEGORY_ID';
export const CLEAR_SEARCH_DATA = 'course/CLEAR_SEARCH_DATA';
 

 








